import moment from "moment";

function feedbackDetails(row) {
    const raw = row?.details;
    if (raw && typeof raw === "object" && !Array.isArray(raw)) {
        return raw;
    }
    if (typeof raw === "string" && raw.trim()) {
        try {
            const parsed = JSON.parse(raw);
            if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) {
                return parsed;
            }
        } catch {
            return {};
        }
    }
    return {};
}

function detailText(row, key) {
    const value = feedbackDetails(row)[key];
    if (value == null) return "";
    const text = String(value).trim();
    return text;
}

export function getFeedbackColumns() {
    return [
        {
            field: "appName",
            headerName: "App",
            width: 200,
            valueGetter: (value, row) => detailText(row, "appName") || "—"
        },
        {
            field: "os",
            headerName: "OS",
            width: 180,
            valueGetter: (value, row) => detailText(row, "os") || "—"
        },
        {
            field: "comment",
            headerName: "Comment",
            flex: 1.2,
            minWidth: 200,
            valueGetter: (value, row) => row.comment || "",
            valueFormatter: (value) => {
                const s = value || "";
                return s.length > 120 ? `${s.slice(0, 120)}…` : s;
            }
        },
        {
            field: "createdAt",
            headerName: "Created",
            width: 170,
            valueGetter: (value, row) => row.createdAt,
            valueFormatter: (value) => (value != null ? moment(value).format("YYYY-MM-DD HH:mm:ss") : "")
        }
    ];
}
